import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Homepage from './pages/Homepage';
import ResultsPage from './pages/ResultsPage';
import ToolDetailPage from './pages/ToolDetailPage';
import ComparePage from './pages/ComparePage';
import PromptHelperPage from './pages/PromptHelperPage';
// import LearnPage from './pages/LearnPage'; // Unpublished - draft only
import TransparencyPage from './pages/TransparencyPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsPage from './pages/TermsPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import { Toaster } from './components/ui/sonner';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/results" element={<ResultsPage />} />
        <Route path="/tool/:id" element={<ToolDetailPage />} />
        <Route path="/compare" element={<ComparePage />} />
        <Route path="/prompt-helper" element={<PromptHelperPage />} />
        {/* Learn page unpublished - redirects to homepage */}
        <Route path="/learn" element={<Homepage />} />
        <Route path="/transparency" element={<TransparencyPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;